import React, { useCallback, useState, useEffect } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import './autocomplete.module.css';
import { Package } from 'types/package';
import { toast } from 'react-toastify';
import { api } from 'services/api';
import PackageItem from './PackageItem';

let timer: NodeJS.Timeout;

interface AutocompleteFromProps {
  onSelect(value: Package | null): void;
  label: string;
  placeholder: string;
  selected: Package | null;
  helperText?: string;
  error?: boolean;
}

const PackagesAutoComplete: React.FC<AutocompleteFromProps> = ({
  onSelect,
  label,
  placeholder,
  selected,
  helperText = '',
  error = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [filtered, setFiltered] = useState<Package[]>([]);
  const [options, setOptions] = useState<Package[]>([]);

  const handleSelect = useCallback(
    (option: Package) => {
      onSelect(option);
      setFiltered([]);
    },
    [onSelect],
  );

  useEffect(() => {
    setFiltered(options);
  }, [options]);

  const findPackages = useCallback(async (term: string) => {
    setLoading(true);
    api
      .get('/packages/all', { params: { name: term, active: 1 } })
      .then(response => {
        setOptions(response.data);
      })
      .catch(err => {
        toast.error('Ocorreu um erro ao buscar os pacotes');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  function handleChange(value: string) {
    clearTimeout(timer);

    if (value.length < 2) {
      return;
    }

    timer = setTimeout(() => findPackages(value), 400);
  }

  return (
    <Autocomplete
      value={selected}
      options={filtered}
      noOptionsText="Nenhum pacote encontrado"
      getOptionLabel={option => option.name}
      onChange={(event, newValue) => onSelect(newValue)}
      renderOption={(props, option) => (
        <PackageItem {...props} key={option.id} handleSelect={handleSelect} option={option} selected={selected} />
      )}
      renderInput={params => (
        <TextField
          {...params}
          onBlur={() => setFiltered([])}
          onChange={e => handleChange(e.target.value)}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText || 'Digite 2 ou mais caracteres'}
          fullWidth
        />
      )}
    />
  );
};

export default PackagesAutoComplete;
